import React from 'react'
import PunchIn from './PunchIn'
// import HrAttendanceDashboard from './HrAttendanceDashboard'

const AttendanceReport = () => {
  return (
    <>
    <h1>AttendanceReport</h1>
    <PunchIn/>
    {/* <HrAttendanceDashboard/> */}
    
    </>
  )
}

export default AttendanceReport